import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classes from './NavbarElement.module.css';

const NavbarElement = ({ link, label, selected }) => (
  <Link
    className={`${classes.navElement} ${selected ? classes.selected : ''}`}
    to={link}
  >
    {label}
  </Link>
);

NavbarElement.propTypes = {
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default NavbarElement;
